import styled from 'styled-components'

export const AddressVerificationWrapper = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.blue};
  background: ${({ theme }) => `linear-gradient(25deg, ${theme.colors.lightGray} 65%, ${theme.colors.blue} 130%)`};
`

export const AddressVerificationInnerWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LoadingWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px;
`

export const AddressVerificationFormContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
`

export const AddressVerificationLogoLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0px;
  margin-top: 50px;

  & svg {
    width: 100px;
    height: 50px;
    & path {
      fill: ${({ theme }) => theme.colors.darkGray};
    }
  }
`
export const AddressVerificationTitle = styled.h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkGray};
  margin: 0 0 5px 0;
`
export const AddressVerificationText = styled.p`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.darkGray};
  margin: 0;
`

export const AddressVerificationBrandWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  min-height: 100vh;
`

export const AddressVerificationBottomWrapper = styled.div`
  align-self: center;

  //TODO: Style Variable
  color: ${({ theme }) => theme.colors.white};
`

export const PrivacyPolicyLink = styled.a`
  display: block;
  margin: 20px 0px 0px 0px;
  width: 100%;

  font-weight: 400;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;

  color: ${({ theme }) => theme.colors.darkGray};
`

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  border-radius: 15px;
  background: ${({ theme }) => `${theme.colors.green}30`};
  border: 2px solid ${({ theme }) => `${theme.colors.green}`};
`

export const ErrWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  border-radius: 15px;
  background: ${({ theme }) => `${theme.colors.red}30`};
  border: 2px solid ${({ theme }) => `${theme.colors.red}`};
`
